import * as logger from 'logger';
import * as tenantService from 'services/tenant-service';
import { addAlert } from 'services/alert-service';
import { addOrUpdateCompletedItem, getItemAlertMessage } from 'services/item-service';
import { convertMsToSeconds, getElapsedMsSinceRequestStarted } from 'helpers/date-helper';
import { getI18n, translateToLanguage } from 'services/i18n-service';
import { NmvsResponse } from 'types/api/nmvs-response';
import { OperationItem } from 'types/operation-item';
import { SinglePackResponse } from 'types/api/single-pack-response';
import { translations } from 'types/translations';

export async function handleAlert(clientTransactionId: string, item: OperationItem, response: NmvsResponse<SinglePackResponse>) {
  item.epc.status = response.error.epcStatus;
  item.hasAlert = true;
  item.alertMessage = getItemAlertMessage(response.error.key, response.error.message);
  await addAlert(clientTransactionId, item, response.error.key, response.error.message, '');
  await addOrUpdateCompletedItem(clientTransactionId, item);
}

export async function handleError(clientTransactionId: string, item: OperationItem) {
  item.hasError = true;
  item.epc.status = 'Error';
  item.totalResponseTime = convertMsToSeconds(getElapsedMsSinceRequestStarted(item, new Date()));

  await addOrUpdateCompletedItem(clientTransactionId, item);
}

export async function getNmvsWarning() {
  const i18n = getI18n();
  const languageCode = await tenantService.getLanguageCode();
  await translateToLanguage(languageCode);
  const alertReason = i18n.t(translations.WarningFromNmvs);
  return alertReason;
}

export async function removeLongPendingItems(operationItems: OperationItem[]): Promise<OperationItem[]> {
  const validOperationItems: OperationItem[] = [];
  let errorEpcs: string = '';

  operationItems.forEach(async item => {
    const diffInSeconds = getElapsedMsSinceRequestStarted(item, new Date()) / 1000;
    if (diffInSeconds > 60) {
      errorEpcs += item.epc.rawCode + '; ';
      await handleError(item.clientTransactionId, item);
    } else {
      validOperationItems.push(item);
    }
  });

  if (errorEpcs.length > 0) {
    logger.error(new Error('pending item timed out'), 'service-worker.removeLongPendingItems', errorEpcs);
  }

  return validOperationItems;
}


// WEBPACK FOOTER //
// ./src/service-worker/helpers/data-sync-error-helpers.ts